import ticketFilterQueryUtility from './ticketFilterQuery.utility.js'
import ticketActorTabUtility from './ticketActorTab.utility.js'
import managementViewModeUtility from './managementViewMode.utility.js'

const TAB_TICKETS = 'tickets'
const TAB_TASKS = 'tasks'

function read(query = {}) {
  if (Object.prototype.hasOwnProperty.call(query, 'task')) return TAB_TASKS
  if (Object.prototype.hasOwnProperty.call(query, 'ticket')) return TAB_TICKETS
  return TAB_TICKETS
}

function hasTab(query = {}) {
  return Object.prototype.hasOwnProperty.call(query, 'task') || Object.prototype.hasOwnProperty.call(query, 'ticket')
}

function withTab(query = {}, active = TAB_TICKETS) {
  const next = { ...query }
  delete next.ticket
  delete next.task
  if (active === TAB_TASKS) next.task = ''
  else next.ticket = ''
  return next
}

/** Scope, list tab, actor tab, view mode, and searched filters when returning from the ticket editor. */
function pickForReturn(query = {}) {
  const next = ticketFilterQueryUtility.withFilters({}, ticketFilterQueryUtility.read(query))
  if (query.ticketGroup != null && query.ticketGroup !== '') next.ticketGroup = query.ticketGroup
  if (Object.prototype.hasOwnProperty.call(query, 'task')) next.task = query.task ?? ''
  else next.ticket = query.ticket ?? ''
  return managementViewModeUtility.withTab(
    ticketActorTabUtility.withTab(next, ticketActorTabUtility.read(query)),
    managementViewModeUtility.read(query),
  )
}

class ManagementListTabUtility {
  TAB_TICKETS = TAB_TICKETS
  TAB_TASKS = TAB_TASKS

  read(query) {
    return read(query)
  }

  hasTab(query) {
    return hasTab(query)
  }

  withTab(query, active) {
    return withTab(query, active)
  }

  pickForReturn(query) {
    return pickForReturn(query)
  }
}

export default new ManagementListTabUtility()
